import React from 'react';
import { createIcon } from '@chakra-ui/react';

const EMPTY_PATH_COLOR = '#a7a7a7';

// eslint-disable max-len
export const createCustomWifiIcon = (signalLevel = 0, signalIconColor: string) => {
  return createIcon({
    displayName: 'WifiIcon',
    path: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="meter-comms-icon-wifi"
      >
        <path
          d="M14.094 18.0009L12.0001 20.2977L9.92163 18.0009C10.1706 17.6867 10.4874 17.4329 10.8483 17.2584C11.2092 17.084 11.6048 16.9933 12.0057 16.9933C12.4065 16.9933 12.8022 17.084 13.1631 17.2584C13.524 17.4329 13.8408 17.6867 14.0898 18.0009H14.094Z"
          fill={signalLevel > 0 ? signalIconColor : EMPTY_PATH_COLOR}
        />
        <path
          d="M15.5949 15.0005C14.6081 14.1234 13.3338 13.639 12.0136 13.639C10.6934 13.639 9.41912 14.1234 8.43237 15.0005"
          stroke={signalLevel > 1 ? signalIconColor : EMPTY_PATH_COLOR}
          strokeWidth="2.3"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M18.4565 12.1408C16.7088 10.5067 14.4056 9.5976 12.013 9.5976C9.62041 9.5976 7.31719 10.5067 5.56958 12.1408"
          stroke={signalLevel > 2 ? signalIconColor : EMPTY_PATH_COLOR}
          strokeWidth="2.3"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M21.0001 8.97834C18.5267 6.77181 15.3279 5.55237 12.0132 5.55237C8.69861 5.55237 5.49982 6.77181 3.02637 8.97834"
          stroke={signalLevel > 3 ? signalIconColor : EMPTY_PATH_COLOR}
          strokeWidth="2.3"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 24 24',
  });
};

export const createCustomCellularIcon = (signalLevel = 0, signalIconColor: string) => {
  return createIcon({
    displayName: 'CellularIcon',
    path: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="meter-comms-icon-cellular"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M22.125 20.2491H19.875C19.5766 20.2491 19.2905 20.1306 19.0795 19.9196C18.8685 19.7087 18.75 19.4225 18.75 19.1241V4.87415C18.75 4.57578 18.8685 4.28963 19.0795 4.07865C19.2905 3.86767 19.5766 3.74915 19.875 3.74915H22.125C22.4234 3.74915 22.7095 3.86767 22.9205 4.07865C23.1315 4.28963 23.25 4.57578 23.25 4.87415V19.1241C23.25 19.4225 23.1315 19.7087 22.9205 19.9196C22.7095 20.1306 22.4234 20.2491 22.125 20.2491Z"
            fill={signalLevel > 3 ? signalIconColor : EMPTY_PATH_COLOR}
          />
          <path
            d="M16.125 20.2494H13.875C13.5766 20.2494 13.2905 20.1309 13.0795 19.9199C12.8685 19.709 12.75 19.4228 12.75 19.1244V8.62445C12.75 8.32608 12.8685 8.03993 13.0795 7.82896C13.2905 7.61798 13.5766 7.49945 13.875 7.49945H16.125C16.4234 7.49945 16.7095 7.61798 16.9205 7.82896C17.1315 8.03993 17.25 8.32608 17.25 8.62445V19.1244C17.25 19.4228 17.1315 19.709 16.9205 19.9199C16.7095 20.1309 16.4234 20.2494 16.125 20.2494Z"
            fill={signalLevel > 2 ? signalIconColor : EMPTY_PATH_COLOR}
          />
          <path
            d="M10.125 20.2491H7.875C7.57663 20.2491 7.29048 20.1306 7.0795 19.9196C6.86853 19.7087 6.75 19.4225 6.75 19.1241V11.6241C6.75 11.3258 6.86853 11.0396 7.0795 10.8287C7.29048 10.6177 7.57663 10.4991 7.875 10.4991H10.125C10.4234 10.4991 10.7095 10.6177 10.9205 10.8287C11.1315 11.0396 11.25 11.3258 11.25 11.6241V19.1241C11.25 19.4225 11.1315 19.7087 10.9205 19.9196C10.7095 20.1306 10.4234 20.2491 10.125 20.2491Z"
            fill={signalLevel > 1 ? signalIconColor : EMPTY_PATH_COLOR}
          />
          <path
            d="M4.125 20.2499H1.875C1.57663 20.2499 1.29048 20.1313 1.0795 19.9204C0.868526 19.7094 0.75 19.4232 0.75 19.1249V14.6249C0.75 14.3265 0.868526 14.0404 1.0795 13.8294C1.29048 13.6184 1.57663 13.4999 1.875 13.4999H4.125C4.42337 13.4999 4.70952 13.6184 4.92049 13.8294C5.13147 14.0404 5.25 14.3265 5.25 14.6249V19.1249C5.25 19.4232 5.13147 19.7094 4.92049 19.9204C4.70952 20.1313 4.42337 20.2499 4.125 20.2499Z"
            fill={signalLevel > 0 ? signalIconColor : EMPTY_PATH_COLOR}
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    viewBox: '0 0 24 24',
  });
};

export const createCustomEthernetIcon = (signalLevel = 0, signalIconColor: string) => {
  const fill = signalLevel > 0 ? signalIconColor : EMPTY_PATH_COLOR;
  return createIcon({
    displayName: 'EthernetIcon',
    path: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        data-testid="meter-comms-icon-ethernet"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M8.176 19.529H15.824C16.057 19.529 16.241 19.345 16.241 19.112V17.189H17.847C18.08 17.189 18.264 17.005 18.264 16.772V14.414H20.471C20.704 14.414 20.888 14.23 20.888 13.997V4.267C20.888 4.034 20.703 3.85 20.471 3.85H3.529C3.296 3.85 3.112 4.034 3.112 4.267V13.995C3.112 14.228 3.296 14.412 3.529 14.412H5.736V16.77C5.736 17.003 5.92 17.187 6.153 17.187H7.759V19.11C7.759 19.343 7.943 19.527 8.176 19.527V19.529ZM6.552 16.013V13.995C6.552 13.762 6.368 13.578 6.135 13.578H4.929V4.762H19.071V13.578H17.264C17.031 13.578 16.847 13.762 16.847 13.995V16.013H15.241C15.008 16.013 14.824 16.197 14.824 16.43V18.352H9.176V16.43C9.176 16.197 8.992 16.013 8.759 16.013H6.552Z"
            fill={fill}
          />
          <path
            d="M22.2 0H1.8C0.809 0 0 0.809 0 1.8V21.6C0 22.591 0.809 23.4 1.8 23.4H22.2C23.191 23.4 24 22.591 24 21.6V1.8C24 0.809 23.191 0 22.2 0ZM23.04 21.6C23.04 22.056 22.656 22.44 22.2 22.44H1.8C1.344 22.44 0.96 22.056 0.96 21.6V1.8C0.96 1.344 1.344 0.96 1.8 0.96H22.2C22.656 0.96 23.04 1.344 23.04 1.8V21.6Z"
            fill={fill}
          />
          <path
            d="M17.568 6.426C17.335 6.426 17.151 6.61 17.151 6.843V9.9C17.151 10.133 17.335 10.317 17.568 10.317C17.801 10.317 17.985 10.133 17.985 9.9V6.843C17.985 6.61 17.801 6.426 17.568 6.426Z"
            fill={fill}
          />
          <path
            d="M14.4 6.426C14.167 6.426 13.983 6.61 13.983 6.843V9.9C13.983 10.133 14.167 10.317 14.4 10.317C14.633 10.317 14.817 10.133 14.817 9.9V6.843C14.817 6.61 14.633 6.426 14.4 6.426Z"
            fill={fill}
          />
          <path
            d="M11.232 6.426C10.999 6.426 10.815 6.61 10.815 6.843V9.9C10.815 10.133 10.999 10.317 11.232 10.317C11.465 10.317 11.649 10.133 11.649 9.9V6.843C11.649 6.61 11.465 6.426 11.232 6.426Z"
            fill={fill}
          />
          <path
            d="M8.064 6.426C7.831 6.426 7.647 6.61 7.647 6.843V9.9C7.647 10.133 7.831 10.317 8.064 10.317C8.297 10.317 8.481 10.133 8.481 9.9V6.843C8.481 6.61 8.297 6.426 8.064 6.426Z"
            fill={fill}
          />
          <path
            d="M4.896 6.426C4.663 6.426 4.479 6.61 4.479 6.843V9.9C4.479 10.133 4.663 10.317 4.896 10.317C5.129 10.317 5.313 10.133 5.313 9.9V6.843C5.313 6.61 5.129 6.426 4.896 6.426Z"
            fill={fill}
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    viewBox: '0 0 24 24',
  });
};

export const createCustomNoneIcon = () =>
  createIcon({
    displayName: 'NoneIcon',
    viewBox: '0 0 24 24',
    path: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g></g>
      </svg>
    ),
  });
